import {FormControl, FormGroup} from '@angular/forms';
import {map} from 'rxjs/operators';

import {
    HttpStatusCodesEnum,
    PermissionsService,
    ServerResponse,
    ServerResponseData,
    UserPermissionWrapper
} from '@spa/api';

import {Helper} from 'appShared/classes';
import {BaseControl} from 'appShared/classes/controls';
import {
    OPERATOR_DEPARTMENT_KEY,
    OperatorPermissionFilterControls,
    prepareDepartmentOptions,
    prepareDepartmentSelect,
} from 'appAssets/descriptors';
import {OperatorPermissionFilterFormErrorStatesEnum} from 'appEntries/panel/enums';
import {BaseValidationFrom} from 'appEntries/panel/forms/base-validation.form';

export class OperatorPermissionFilterForm extends BaseValidationFrom<BaseControl[]> {
    constructor(
        private readonly permissionsService: PermissionsService,
        public userPermissionFilter: UserPermissionWrapper,
        private readonly allDepartments: string[],
    ) {
        super();
    }

    initForm(): void {
        this.form = new FormGroup({});
        const departmentControls = OperatorPermissionFilterControls();

        const allDepartments = prepareDepartmentOptions(this.allDepartments);

        this.userPermissionFilter.permissions.forEach(permission => {
            const isNotList = permission.permission_filters?.findIndex(
                filter => filter.filter_key === OPERATOR_DEPARTMENT_KEY && filter.is_list
            ) < 0;

            const selectedDepartments = permission.permission_filters?.find(
                filter => filter.filter_key === OPERATOR_DEPARTMENT_KEY
            )?.values;

            const selectControl = prepareDepartmentSelect(permission.id, !isNotList);
            selectControl.options = isNotList ? prepareDepartmentOptions(selectedDepartments) : allDepartments;
            selectControl.value = selectedDepartments;
            departmentControls.push(selectControl);
        });

        this.controls = departmentControls.map((control: BaseControl) => {
            this.form.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });
    }

    createRequest(): ServerResponse<UserPermissionWrapper> {
        // tslint:disable-next-line:forin
        for (const property in this.form.value) {
            this.userPermissionFilter.permissions.find(
                permission => permission.id === Number(property)
            ).permission_filters.find(
                filter => filter.filter_key === OPERATOR_DEPARTMENT_KEY
            ).values = this.form.value[property];
        }

        return this.permissionsService.updateUserPermissionFilters(this.userPermissionFilter.user_id, this.userPermissionFilter).pipe(
            map((registerResponse: ServerResponseData<boolean>) => {
                if (registerResponse.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponse<UserPermissionWrapper>(
                        null,
                        OperatorPermissionFilterFormErrorStatesEnum.UpdateOperatorPermissionFilterFailed
                    );
                }

                return Helper.createSuccessResponse<UserPermissionWrapper>(this.userPermissionFilter);
            })
        );
    }
}
